import 'regenerator-runtime/runtime';
import { put, call, takeEvery, takeLatest, all } from 'redux-saga/effects';
import {
  searchRooms,
  addRoom,
  editRoom,
  getById,
  makeActive,
  makeInActive,
  getSelectListRooms,
  fetchHomeownerRoomSelectList
} from './api';
import * as RoomActionType from './constants';
import * as NotifyActionType from '../Notification/constants';

import { sendAjaxRequest } from 'helper/interceptors';
import { AppSettings } from '../constants';


export function* getByIdAsync(action) {

  const result = yield call(getById, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({ type: RoomActionType.GET_ROOM_BY_ID_SUCCESS, data: result.data });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* searchRoomAsync(action) {

  const result = yield call(searchRooms, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    if (action.callback) {
      action.callback(result.data);
    }
    yield put({
      type: RoomActionType.SEARCH_ROOM_SUCCESS,
      data: {
        data: result.data,
        params: action.params
      }
    });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* createRoomAsync(action) {

  const result = yield call(addRoom, action.params.data);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: RoomActionType.SEARCH_ROOM_ASYNC, params: action.params.search }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Location created' })
    ];
  } else {
    yield put({ type: RoomActionType.ADD_EDIT_ROOM_ERROR, data: { error: result.data, params: action.params.data } });
  }
}

export function* updateDefaultConfigsAsync(action) {
  const configResult = yield call(
    sendAjaxRequest,
    AppSettings.CURRENT_SITE_URI,
    `/api/request-for-services/CreateBulkDefaultConfigs?ConfigSettingsStringifyText=${JSON.stringify(action.params.ConfigSettingsStringifyText)}`,
    {},//ConfigSettingsStringifyText:action.params.ConfigSettingsStringifyText},
    'POST'
  );
  const statusCode = configResult.statusCode;
  if (statusCode === 200) {
    yield [put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'All configurations saved sucessfully!' })];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: configResult.data });
  }
}

export function* updateRoomAsync(action) {

  const result = yield call(editRoom, action.params.data);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: RoomActionType.SEARCH_ROOM_ASYNC, params: action.params.search }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
  } else {
    yield put({ type: RoomActionType.ADD_EDIT_ROOM_ERROR, data: { error: result.data, params: action.params.data } });
  }
}

export function* makeActiveAsync(action) {

  const result = yield call(makeActive, action.params.data);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: RoomActionType.SEARCH_ROOM_ASYNC, params: action.params.search }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: { data: result.data } });
  }
}

export function* makeInActiveAsync(action) {

  const result = yield call(makeInActive, action.params.data);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: RoomActionType.SEARCH_ROOM_ASYNC, params: action.params.search }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: { data: result.data } });
  }
}

export function* getSelectListRoomAsync(action) {

  const result = yield call(getSelectListRooms, action.params.param);

  const statusCode = result.statusCode;

  if (statusCode === 200) {

    let actionTypes = processAfterSuccess(action, result);

    yield [actionTypes];

  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* fetchHomeownerRoomSelectListAsync(action) {
  const result = yield call(fetchHomeownerRoomSelectList, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    if (action.callback) {
      action.callback();
    }
    yield put({type: RoomActionType.FETCH_HOMEOWNER_ROOM_SELECT_LIST_SUCCESS, data: result.data});

  } else {
    if (action.callback) {
      action.callback();
    }
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export default function* WatchRoom() {
  yield all([
    takeLatest(RoomActionType.SEARCH_ROOM_ASYNC, searchRoomAsync),
    takeLatest(RoomActionType.GET_ROOM_BY_ID_ASYNC, getByIdAsync),
    takeEvery(RoomActionType.CREATE_ROOM_ASYNC, createRoomAsync),
    takeEvery(RoomActionType.UPDATE_ROOM_ASYNC, updateRoomAsync),
    takeEvery(RoomActionType.UPDATE_DEFAULT_CONFIGS_ASYNC, updateDefaultConfigsAsync),
    takeEvery(RoomActionType.MAKE_ACTIVE_ROOM_ASYNC, makeActiveAsync),
    takeEvery(RoomActionType.MAKE_INACTIVE_ROOM_ASYNC, makeInActiveAsync),
    takeLatest(RoomActionType.SELECT_LIST_ROOM_ASYNC, getSelectListRoomAsync),
    takeLatest(RoomActionType.FETCH_HOMEOWNER_ROOM_SELECT_LIST_ASYNC, fetchHomeownerRoomSelectListAsync)
  ]);
}

const processAfterSuccess = (action, result) => {
  var actionTypes = [];

  action.params.nextAction.forEach(item => {
    if (item.params === null && typeof (item.action) !== 'undefined') {
      actionTypes.push(put({ type: item.action, data: result.data, internalParams: item['internalParams'] }));
    }

    if (item.params !== null && typeof (item.action) !== 'undefined') {
      actionTypes.push(put({ type: item.action, params: item.params }));
    }

    if (item.callBack) {
      item.callBack(result.data);
    }
  });

  return actionTypes;
};



// WEBPACK FOOTER //
// ./src/Rooms/saga.js